document.addEventListener('DOMContentLoaded', () => {
  const indexContentDiv = document.querySelector('.IndexContent');
  const indexContentLinks = document.querySelectorAll('.IndexContent a');

  if (!indexContentDiv) {
    return;
  }

  const getAnchorName = (anchor) => (anchor === '#periodo' ? 'calendario-do-curso' : anchor.replace('#', ''));

  indexContentLinks.forEach((link) => {
    const anchor = link.getAttribute('href');
    const id = getAnchorName(anchor);

    if (!document.getElementById(id)) {
      link.style.display = 'none';
    }
  });

  indexContentDiv.addEventListener('click', (e) => {
    if (e.target.localName === 'a') {
      e.preventDefault();

      const anchor = e.target.hash;
      const id = getAnchorName(anchor);

      const element = jQuery(`#${id}`);

      if (element.length > 0) {
        const headerHeight = window.outerWidth > 1024 ? 0 : jQuery('.Header').outerHeight(true);
        const offsetTop = element.offset().top - headerHeight - jQuery('.heading-wrapper').outerHeight(true) - jQuery('.IndexContent').outerHeight(true);

        jQuery('.heading-wrapper').addClass('sticky');
        jQuery('.course-content--modalities').addClass('sticky');
        jQuery('.heading-wrapper .Heading').addClass('minimized');

        window.scroll({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    }
  });

  document.addEventListener('scroll', () => {
    indexContentLinks.forEach((link) => {
      const anchor = jQuery(link).attr('href');
      const id = getAnchorName(anchor);
      const element = jQuery(`#${id}`);

      if (element.length > 0) {
        const windowScrollY = Math.round(window.scrollY);
        const elementPosition = Math.round(element.offset().top) - 240;
        const elementPostionEnd = elementPosition + Math.round(element.height());

        if (windowScrollY >= elementPosition && windowScrollY < elementPostionEnd) {
          jQuery('.IndexContent a.active').removeClass('active');
          jQuery(link).addClass('active');
        }
      }
    });
  });
});
